/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
/**
 * @fileoverview Client module `shared` for the Caintra Connect frontend.
 * @module components/Events/EventListItem/shared
 *
 * Conventions:
 * - Keep components focused on rendering; move branching logic into hooks or utils.
 * - Prefer named exports for helpers and default exports for React components.
 * - Reuse shared validation, i18n, and API helpers from client/src/utils and logic/.
 */
import dayjs from "dayjs";
import { SvgIcon } from "@mui/material";
import { generateAssetUrl } from "../../../utils/common.js";
import AssetImage from "../../AssetImage";
import Caintra_Logo_03 from "../../../assets/Caintra_Logo_03.png";
import EventBanner from "../../../assets/EventBanner.png";
import { ReactComponent as CheckIcon } from "../../../assets/icons/Check.svg";

export const EventCardShell = ({ event, styles, children, eventKey }) => (
  <div key={eventKey} className={styles.eventCard}>
    <AssetImage
      className={styles.eventImage}
      src={
        event.imagenBanner ? generateAssetUrl(event.imagenBanner) : EventBanner
      }
      alt=""
    />
    <div className={styles.eventInfo}>
      <div className={styles.eventHeader}>
        <div className={styles.eventHeaderTitle}>
          <div className={styles.messageItemAvatar}>
            <img className={styles.avatar} src={Caintra_Logo_03} alt="" />
          </div>
          <span className={styles.eventName}>{event.nombre}</span>
        </div>
      </div>
      {children}
    </div>
  </div>
);

export const SingleEventDate = ({ eventDate, styles }) => (
  <>
    <span className={styles.dayOfWeek}>
      {dayjs(eventDate).utc().format("dddd")}
    </span>
    <span className={styles.day}>{dayjs(eventDate).utc().format("DD")}</span>
    <span className={styles.monthAndYear}>
      {dayjs(eventDate).utc().format("MMMM")}
      {", "}
      {dayjs(eventDate).utc().format("YYYY")}
    </span>
  </>
);

export const RegisteredStatusTag = ({ t, styles }) => (
  <div className={styles.eventTags}>
    <div className={styles.registrationStatus}>
      <SvgIcon sx={{ fontSize: "14px", color: "#2A995A" }} component={CheckIcon} />
      {t("pages.events.registered")}
    </div>
  </div>
);

export const EventDetailColumn = ({ icon: Icon, label, value, styles }) => (
  <div className={styles.eventColumn}>
    <div className={styles.eventColumnItem}>
      <Icon className={styles.salesIcon} />
      <label className={styles.eventLabel}>{label}</label>
    </div>
    <span className={styles.eventValue}>{value}</span>
  </div>
);
